import { useEffect } from 'react';

export default function useAutoLogout(logoutFn, timeout = 15 * 60 * 1000) {
  useEffect(() => {
    if (!logoutFn) return;

    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logoutFn, timeout);
    };

    const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(evt => window.addEventListener(evt, resetTimer));

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach(evt => window.removeEventListener(evt, resetTimer));
    };
  }, [logoutFn, timeout]);
}